module.exports = __webpack_public_path__ + "images/1-en.jpg?v=9584b3fdf1095cce8d0ea00ae76e2b7e";